import { render, staticRenderFns } from "./AttachmentsForTenant.vue?vue&type=template&id=1e5669ac&"
import script from "./AttachmentsForTenant.vue?vue&type=script&lang=js&"
export * from "./AttachmentsForTenant.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsForTenant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5669ac')) {
      api.createRecord('1e5669ac', component.options)
    } else {
      api.reload('1e5669ac', component.options)
    }
    module.hot.accept("./AttachmentsForTenant.vue?vue&type=template&id=1e5669ac&", function () {
      api.rerender('1e5669ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/AttachmentsForTenant.vue"
export default component.exports